<div>
  @if (!isError) {
    <div class="snackbar-body--info">
      <div class="message">
        <mat-icon [svgIcon]="icons.INFO"></mat-icon>
        <div class="message-body">
          <span class="message-text">{{message}}</span>
          @if (hasLink || hasAdditionalInfo) {
            <div  class="addl-link">
              <span class="linkMsg">@if (hasLink) {
                <a [href]="messageUrl" [target]="linkTarget">{{getLinkMessage}}</a>
              }</span>
              <span class="addtlInfo">@if (hasAdditionalInfo) {
                <a (click)="showAdditionalInfoDialog()">Additional Information</a>
              }</span>
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (isError) {
    <div class="snackbar-body--error">
      <div class="message">
        <mat-icon>error</mat-icon>
        <div class="message-body">
          <span class="message-text">{{message}}</span>
          @if (hasLink || hasAdditionalInfo) {
            <div class="addl-link">
              <span class="linkMsg">@if (hasLink) {
                <a [href]="messageUrl" [target]="linkTarget">{{getLinkMessage}}</a>
              }</span>
              <span class="addtlInfo">@if (hasAdditionalInfo) {
                <a (click)="showAdditionalInfoDialog()">Additional Information</a>
              }</span>
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (hasAction) {
    <button type="button" class="close-button" (click)="dismiss()">
      <mat-icon [svgIcon]="icons.CLOSE"></mat-icon>
    </button>
  }

</div>
